// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6375":"3364906086269879","6855":"b05986a332dfee0a"}[chunkId] + ".css";
};